export default "__VITE_ASSET__DXkq8$lh__"